
@if ((prodBanner | json) !== '{}') {
  <a [href]="prodBanner.url" target="_self">
    <img [src]="prodBanner.src" [alt]="prodBanner.alt_text">
  </a>
}



